import { Body1, styled } from "@iventis/styles";
import React, { ChangeEvent, useEffect, useState } from "react";

import { useSubjectContext } from "../../state/subjects-context";

export function MapZoomComponent() {
    const [value, setValue] = useState(0);

    const { mapZoom$ } = useSubjectContext();

    const handleSetZoomLevel = (event: ChangeEvent<HTMLInputElement>) => {
        const updatedValue = Number.parseFloat(Number.parseFloat(event.target.value).toFixed(2));
        setValue(updatedValue);
        mapZoom$.next({ source: "toolbar", value: updatedValue });
    };

    useEffect(() => {
        const sub = mapZoom$.subscribe(({ value, source }) => {
            if (source === "background-map" || source === "cad-map") {
                setValue(Number.parseFloat(value.toFixed(2)));
            }
        });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    return (
        <ControlContainer>
            <Body1>Zoom level</Body1>
            <input type="number" className="zoom-input" value={value} onChange={handleSetZoomLevel} step={0.01} />
            <input type="range" value={value} onChange={handleSetZoomLevel} max={24} min={1} step={0.01} />
        </ControlContainer>
    );
}

export const ControlContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    justify-content: center;
    align-items: flex-start;

    .control-label {
        width: 200px;
    }
`;
